export type AnalyticsPageScope = "public" | "app";

const PAGE_VIEW_EVENTS: Record<AnalyticsPageScope, string> = {
  public: "public_page_viewed",
  app: "app_page_viewed",
};

export function getPageViewEventName(scope: AnalyticsPageScope): string {
  return PAGE_VIEW_EVENTS[scope];
}
